import * as React from 'react';
import { StyleSheet } from 'react-native';
import { translate } from 'secullum-i18n';
import {
  Card,
  RangeDatePicker,
  DropDown,
  Space,
  Message
} from 'secullum-react-native-ui';
import { Subscribe } from 'unstated';
import AssinaturaDigitalCartaoPontoHeader from '../../../shared/components/AssinaturaDigitalCartaoPontoHeader';
import AssinaturaDigitalCartaoPontoLinha from '../../../shared/components/AssinaturaDigitalCartaoPontoLinha';
import AssinaturaDigitalCartaoPontoProcessamento from '../../../shared/components/AssinaturaDigitalCartaoPontoProcessamento';
import { ButtonBar } from '../../../shared/components/ButtonBar';
import {
  AssinaturaDigitalCartaoPontoContainer,
  getCorStatus,
  getIconeStatus
} from '../../../shared/containers/AssinaturaDigitalCartaoPontoContainer';
import { FuncionarioContainer } from '../../../shared/containers/FuncionarioContainer';
import { ProcessandoContainer } from '../../../shared/containers/ProcessandoContainer';
import withContainer from '../../../shared/containers/withContainer';
import Api from '../../../shared/modules/api';
import {
  GeolocationCoordinates,
  watchGeolocationAsync
} from '../../../shared/modules/geolocation';
import { getTheme } from '../../../shared/modules/layout';
import {
  AssinaturaDigitalCartaoPontoFiltrosStatus,
  TipoAlteracaoAssinaturaDigitalCartaoPonto,
  AssinaturaDigitalCartaoPontoDados,
  AssinaturaDigitalCartaoPontoStatus,
  DadosListagemFuncionariosGerente,
  TipoPerfil
} from '../../../shared/modules/types';
import {
  converterDataParaTimezoneBrasil,
  getDataInicioDiasAtras
} from '../../../shared/modules/utils';
import LoggedInScreen from '../../components/LoggedInScreen';
import { RouteComponentComBancoIdProps } from '../../modules/routes';
import AssinaturasDigitaisCartaoPontoDetalhes from '../assinatura-digital-cartao-ponto/AssinaturasDigitaisCartaoPontoDetalhes';

interface Props
  extends RouteComponentComBancoIdProps<{
    funcionarioSelecionadoId?: number;
  }> {
  container: AssinaturaDigitalCartaoPontoContainer;
  funcionarioContainer: FuncionarioContainer;
}

interface State {
  filtros: {
    dataInicio: Date;
    dataFinal: Date;
    status: AssinaturaDigitalCartaoPontoFiltrosStatus;
    funcionarioId: number;
    perfil: TipoPerfil;
  };
  funcionariosGerente: DadosListagemFuncionariosGerente[];
  erroGeral: string;
  assinaturaDigitalCartaoPonto: AssinaturaDigitalCartaoPontoDados | null;
  todasSelecionadas: boolean;
  listaIdsSelecionados: Array<number>;
  tipoAcao: TipoAlteracaoAssinaturaDigitalCartaoPonto | null;
  assinaturaDigitalCartaoPontoAtual: AssinaturaDigitalCartaoPontoDados | null;
  erroLocalizacao: string | null;
  coordenadas: GeolocationCoordinates | null;
}

class AssinaturaDigitalCartaoPontoGerente extends React.Component<
  Props,
  State
> {
  state: State = {
    filtros: {
      dataInicio: converterDataParaTimezoneBrasil(getDataInicioDiasAtras(14)),
      dataFinal: converterDataParaTimezoneBrasil(new Date()),
      status:
        AssinaturaDigitalCartaoPontoFiltrosStatus.AguardandoAprovacaoGerentes,
      funcionarioId: 0,
      perfil: TipoPerfil.Gerente
    },
    funcionariosGerente: [],
    erroGeral: '',
    assinaturaDigitalCartaoPonto: null,
    todasSelecionadas: false,
    listaIdsSelecionados: [],
    tipoAcao: null,
    assinaturaDigitalCartaoPontoAtual: null,
    erroLocalizacao: null,
    coordenadas: null
  };

  listaAssinaturasDigitaisCartaoPontoAtualAcao: AssinaturaDigitalCartaoPontoDados[] =
    [];

  unsubscribeLocation: (() => void) | undefined;

  componentWillUnmount() {
    this.unsubscribeLocation?.();
  }

  async componentDidMount() {
    await Promise.all([
      this.carregarListaFuncionarios(),
      this.watchGeolocation(),
      this.handleRefresh()
    ]);
  }

  carregarListaFuncionarios = async () => {
    const api = new Api();

    const { dados: funcionarioDados } = this.props.funcionarioContainer.state;

    await api.getListaFuncionariosGerente({
      onSuccess: listaOriginal => {
        const funcionariosFiltrados = listaOriginal.filter(
          x => x.id !== funcionarioDados.id
        );

        const todosItem = { id: 0, nome: translate('Todos') };
        const funcionariosGerente = [todosItem, ...funcionariosFiltrados];

        this.setState({ funcionariosGerente });
      },
      onError: resp => {
        this.setState({
          erroGeral: resp.message
        });
      }
    });
  };

  watchGeolocation = async () => {
    this.unsubscribeLocation = await watchGeolocationAsync({
      onChange: coordenadas => this.setState({ coordenadas }),
      onError: erroLocalizacao => this.setState({ erroLocalizacao }),
      detectAddress: true
    });
  };

  handleRefresh = async () => {
    await this.props.container.loadAsync(this.state.filtros);
  };

  handleDateInicioChange = (value: Date, name: keyof State['filtros']) => {
    this.setState(prevState => ({
      filtros: {
        ...prevState.filtros,
        dataInicio: value,
        dataFinal: value
      },
      erroGeral: ''
    }));
  };

  handleChange = (value: string | Date, name: keyof State['filtros']) => {
    this.setState(
      prevState => ({
        listaIdsSelecionados: [],
        filtros: {
          ...prevState.filtros,
          [name]: value
        },
        erroGeral: ''
      }),
      async () => {
        if (
          this.state.filtros.dataInicio &&
          this.state.filtros.dataFinal &&
          this.state.filtros.dataInicio > this.state.filtros.dataFinal
        ) {
          this.setState({
            erroGeral: translate('Selecione o período corretamente')
          });

          return;
        }

        await this.handleRefresh();
      }
    );
  };

  iniciarProcessamento = (
    tipoAcao: TipoAlteracaoAssinaturaDigitalCartaoPonto
  ) => {
    const { listaIdsSelecionados } = this.state;
    const { lista } = this.props.container.state;

    this.setState({ tipoAcao });

    this.listaAssinaturasDigitaisCartaoPontoAtualAcao = lista.filter(x =>
      listaIdsSelecionados.find(y => x.id == y)
    );

    this.processarAssinaturaDigitalCartaoPontoAtual();
  };

  processarAssinaturaDigitalCartaoPontoAtual = () => {
    if (this.listaAssinaturasDigitaisCartaoPontoAtualAcao.length === 0) {
      this.finalizarProcessamento();
      return;
    }

    this.setState({
      assinaturaDigitalCartaoPontoAtual:
        this.listaAssinaturasDigitaisCartaoPontoAtualAcao[0]
    });
  };

  finalizarProcessamento = () => {
    this.listaAssinaturasDigitaisCartaoPontoAtualAcao = [];

    this.setState(
      {
        tipoAcao: null,
        assinaturaDigitalCartaoPontoAtual: null,
        todasSelecionadas: false
      },
      async () => await this.handleRefresh()
    );
  };

  concluirEnvioSucesso = () => {
    const { assinaturaDigitalCartaoPontoAtual } = this.state;

    if (assinaturaDigitalCartaoPontoAtual) {
      this.setState(prevState => ({
        listaIdsSelecionados: prevState.listaIdsSelecionados.filter(
          item => item !== assinaturaDigitalCartaoPontoAtual.id
        )
      }));
    }

    this.listaAssinaturasDigitaisCartaoPontoAtualAcao.shift();
    this.processarAssinaturaDigitalCartaoPontoAtual();
  };

  handleSelecionarTodas = (checked: boolean) => {
    const { container } = this.props;

    this.setState({
      todasSelecionadas: checked,
      listaIdsSelecionados: checked
        ? container.state.lista
            .filter(
              x =>
                x.estadoGerente ===
                AssinaturaDigitalCartaoPontoStatus.NaoRespondido
            )
            .map(y => y.id)
        : []
    });
  };

  handleSelecionar = (assinaturaDigitalCartaoPontoId: number) => {
    this.setState(({ listaIdsSelecionados }) => {
      if (listaIdsSelecionados.includes(assinaturaDigitalCartaoPontoId)) {
        return {
          listaIdsSelecionados: listaIdsSelecionados.filter(
            item => item !== assinaturaDigitalCartaoPontoId
          )
        };
      }

      return {
        listaIdsSelecionados: [
          ...listaIdsSelecionados,
          assinaturaDigitalCartaoPontoId
        ]
      };
    });
  };

  handleFuncionarioChange = async (funcionarioId: number) => {
    this.setState(
      prevState => ({
        filtros: {
          ...prevState.filtros,
          funcionarioId
        }
      }),
      async () => {
        await this.handleRefresh();
      }
    );
  };

  render() {
    const { container } = this.props;
    const {
      filtros,
      erroGeral,
      funcionariosGerente,
      todasSelecionadas,
      listaIdsSelecionados,
      assinaturaDigitalCartaoPontoAtual,
      assinaturaDigitalCartaoPonto,
      tipoAcao,
      coordenadas,
      erroLocalizacao
    } = this.state;

    const desabilitarBotoes =
      !listaIdsSelecionados.length || !coordenadas || !!erroLocalizacao;

    const leftButtonAprovar = {
      disabled: desabilitarBotoes,
      text: translate('Aprovar'),
      onPress: () =>
        this.iniciarProcessamento(
          TipoAlteracaoAssinaturaDigitalCartaoPonto.Aprovar
        ),
      textStyle: styles.textButton,
      style: [styles.button, { backgroundColor: theme.successColor }],
      nativeID: 'botao-aprovar-assinatura-digital-cartao-ponto-gerente'
    };

    const rightButton = {
      disabled: desabilitarBotoes,
      text: translate('Reprovar'),
      onPress: () =>
        this.iniciarProcessamento(
          TipoAlteracaoAssinaturaDigitalCartaoPonto.Rejeitar
        ),
      textStyle: styles.textButton,
      style: [styles.button, { backgroundColor: theme.errorColor }],
      nativeID: 'botao-reprovar-assinatura-digital-cartao-ponto-gerente'
    };

    return (
      <LoggedInScreen
        screenTitle={translate('Assinatura Eletrônica de Cartão Ponto')}
      >
        <Card>
          <Card.Header
            nativeID="assinatura-digital-cartao-ponto-filtrar-gerente"
            title={translate('Filtrar')}
          />
          <Card.Section style={styles.section}>
            <DropDown
              nativeID="assinatura-digital-cartao-ponto-funcionarios-gerente"
              style={styles.campoFiltro}
              label={translate('Selecione o funcionário')}
              value={filtros.funcionarioId}
              items={funcionariosGerente.map((x, indice) => ({
                value: x.id,
                label: x.nome,
                nativeID: `funcionario-${indice + 1}`
              }))}
              onChange={funcionarioId =>
                this.handleFuncionarioChange(funcionarioId)
              }
              emptyMessage={translate('Sua busca não retornou resultados')}
            />
            <DropDown
              nativeID="assinatura-digital-cartao-ponto-status-gerente"
              label={translate('Status')}
              items={container.getItensStatusAssinaturaDigitalCartaoPontoGerente()}
              value={filtros.status}
              onChange={status => this.handleChange(status, 'status')}
              style={styles.campoFiltro}
              emptyMessage={translate('Sua busca não retornou resultados')}
            />
            <RangeDatePicker
              nativeID="assinatura-digital-cartao-ponto-data-gerente"
              style={styles.campoFiltro}
              label={translate('Insira o Período')}
              startDate={filtros.dataInicio!}
              endDate={filtros.dataFinal!}
              onStartDateChange={date =>
                this.handleDateInicioChange(date, 'dataInicio')
              }
              onEndDateChange={date => this.handleChange(date, 'dataFinal')}
            />
            <ButtonBar
              buttonBarStyle={styles.buttons}
              leftButton={leftButtonAprovar}
              rightButton={rightButton}
            />
          </Card.Section>
        </Card>
        <Space height={10} />
        <Card>
          <Card.Section style={styles.headerSection}>
            {container.state.lista.length > 0 && (
              <AssinaturaDigitalCartaoPontoHeader
                checked={todasSelecionadas}
                showChecked={
                  container.state.precisaProcessarAssinaturasDigitaisCartaoPonto
                }
                onChecked={checked => this.handleSelecionarTodas(checked)}
                gerente
              />
            )}
          </Card.Section>
        </Card>
        <Space height={10} />
        {container.state.lista.map((assinaturaDigitalCartaoPonto, index) => (
          <AssinaturaDigitalCartaoPontoLinha
            key={assinaturaDigitalCartaoPonto.id}
            nativeID={`assinatura-digital-cartao-ponto-gerente-${index + 1}`}
            exibirSeparador={index > 0}
            assinaturaDigitalCartaoPonto={assinaturaDigitalCartaoPonto}
            checked={listaIdsSelecionados.includes(
              assinaturaDigitalCartaoPonto.id
            )}
            corIconeStatus={getCorStatus(assinaturaDigitalCartaoPonto.estado)}
            iconeStatus={getIconeStatus(assinaturaDigitalCartaoPonto.estado)}
            corIconeStatusGerente={getCorStatus(
              assinaturaDigitalCartaoPonto.estadoGerente ||
                AssinaturaDigitalCartaoPontoStatus.NaoRespondido
            )}
            iconeStatusGerente={getIconeStatus(
              assinaturaDigitalCartaoPonto.estadoGerente ||
                AssinaturaDigitalCartaoPontoStatus.NaoRespondido
            )}
            onChecked={() =>
              this.handleSelecionar(assinaturaDigitalCartaoPonto.id)
            }
            onNavigate={() => {
              this.setState({ assinaturaDigitalCartaoPonto });
            }}
            gerente
          />
        ))}
        {assinaturaDigitalCartaoPonto && (
          <AssinaturasDigitaisCartaoPontoDetalhes
            modalVisible={assinaturaDigitalCartaoPonto !== null}
            assinaturaDigitalCartaoPonto={assinaturaDigitalCartaoPonto}
            onClose={() => {
              this.finalizarProcessamento();
              this.setState({ assinaturaDigitalCartaoPonto: null });
            }}
            coordenadas={coordenadas}
            gerente
          />
        )}
        <Subscribe to={[ProcessandoContainer]}>
          {(processando: ProcessandoContainer) =>
            processando.state.quantidade === 0 &&
            assinaturaDigitalCartaoPontoAtual &&
            coordenadas ? (
              <AssinaturaDigitalCartaoPontoProcessamento
                assinaturaDigitalCartaoPontoAtual={
                  assinaturaDigitalCartaoPontoAtual
                }
                coordenadas={coordenadas}
                tipoAcao={tipoAcao}
                concluirEnvioSucesso={this.concluirEnvioSucesso}
                finalizarProcessamento={this.finalizarProcessamento}
                concluirEnvioErro={(erros: string) =>
                  this.setState(
                    { erroGeral: erros },
                    this.finalizarProcessamento
                  )
                }
                gerente
              />
            ) : null
          }
        </Subscribe>
        <Message
          type="warning"
          visible={erroGeral != ''}
          message={erroGeral}
          onRequestClose={() => this.setState({ erroGeral: '' })}
          nativeID="assinatura-digital-cartao-ponto-mensagem-erro-geral-gerente"
        />
        {erroLocalizacao ? (
          <Message
            type={'warning'}
            visible
            message={erroLocalizacao}
            onRequestClose={() => this.setState({ erroLocalizacao: null })}
            nativeID="assinatura-digital-cartao-ponto-mensagem-erro-localizacao-gerente"
          />
        ) : null}
      </LoggedInScreen>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  headerSection: {
    padding: 0
  },
  campoFiltro: {
    flex: 1,
    minWidth: 250,
    maxWidth: 350,
    marginTop: 10,
    marginLeft: 16
  },
  section: {
    flexDirection: 'row',
    flex: 8,
    flexWrap: 'wrap',
    minHeight: 88,
    paddingTop: 6,
    paddingLeft: 0
  },
  buttons: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 350,
    minWidth: 220,
    marginLeft: 16,
    marginTop: 10
  },
  button: {
    height: 42,
    maxWidth: 138
  },
  textButton: {
    fontSize: 14
  }
});

export default withContainer(
  FuncionarioContainer,
  'funcionarioContainer'
)(
  withContainer(
    AssinaturaDigitalCartaoPontoContainer,
    'container'
  )(AssinaturaDigitalCartaoPontoGerente)
);
